<template>
  <v-dialog
    :value="open"
    :width="600"
    :max-width="1200"
    :min-width="320"
    fullscreen-breakpoint="sm"
    @keydown="$event.key === 'Escape' && toggle()"
    scrollable
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card class="rounded-lg elevation-12">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title class="text-h6 font-weight-medium">
          <v-icon left>mdi-account-plus</v-icon>
          Tạo mới khách hàng
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggle()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-5">
        <p class="text-subtitle-1 grey--text text--darken-1 mb-4">
          Nhập thông tin khách hàng mới để thêm vào hệ thống.
        </p>

        <v-form @submit.prevent="submit" ref="form" v-model="valid">
          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="name"
                label="Tên khách hàng"
                prepend-icon="mdi-account"
                outlined
                dense
                auto-focus
                :rules="nameRules"
                class="mb-2"
                color="primary"
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="phone"
                label="Số điện thoại"
                prepend-icon="mdi-phone"
                outlined
                dense
                :rules="phoneRules"
                class="mb-2"
                color="primary"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-select
                v-model="dataType"
                :items="dataTypeOptions"
                label="Tình trạng khách hàng"
                prepend-icon="mdi-account-tag"
                outlined
                dense
                :rules="[v => !!v || 'Vui lòng chọn phân loại data']"
                class="mb-2"
                color="primary"
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="email"
                label="Email"
                prepend-icon="mdi-email-outline"
                outlined
                dense
                :rules="emailRules"
                class="mb-2"
                color="primary"
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="address"
                label="Địa chỉ"
                prepend-icon="mdi-map-marker"
                outlined
                dense
                class="mb-2"
                color="primary"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
                <v-text-field
                v-model="total_money"
                @input="formatCurrency"
                @focus="$event => $event.target.select()"
                label="Dư nợ khách hàng"
                prepend-icon="mdi-cash"
                outlined
                dense
                class="mb-2"
                color="primary"
                hide-details="auto"
                :suffix="'đ'"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" v-if="isAdminUser">
              <v-select
                v-model="saleUserId"
                :items="saleTabs"
                item-text="sale_name"
                item-value="user_id"
                label="Sale phụ trách"
                prepend-icon="mdi-account-tie"
                outlined
                dense
                clearable
                class="mb-2"
                color="primary"
                hide-details="auto"
                placeholder="Chọn sale phụ trách"
              ></v-select>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="note"
                label="Thông tin chi tiết"
                prepend-icon="mdi-note-text"
                outlined
                dense
                rows="3"
                class="mb-2"
                color="primary"
                hide-details="auto"
                placeholder="Nhập thông tin chi tiết về khách hàng..."
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-select
                v-model="health_needs"
                :items="healthNeedsList"
                label="Nhu cầu sức khỏe"
                prepend-icon="mdi-heart-pulse"
                outlined
                dense
                multiple
                chips
                small-chips
                deletable-chips
                class="mb-2"
                color="primary"
                hide-details="auto"
                placeholder="Chọn nhu cầu sức khỏe..."
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    v-if="index < 3"
                    small
                    close
                    @click:close="removeHealthNeed(item)"
                    color="primary"
                    outlined
                  >
                    {{ item }}
                  </v-chip>
                  <span
                    v-if="index === 3"
                    class="grey--text text-caption"
                  >
                    (+{{ health_needs.length - 3 }} khác)
                  </span>
                </template>
              </v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="createOrderWithCustomer"
                label="Tạo đơn hàng kèm khách hàng"
                color="primary"
                class="mb-4"
                @change="createOrderWithCustomer && fetchProducts()"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-expand-transition>
            <div v-if="createOrderWithCustomer">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    ref="productSearch"
                    v-model="searchProduct"
                    :items="listProduct"
                    placeholder="Tìm hàng hóa"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    hide-selected
                    hide-details
                    hide-no-data
                    hide-spin-buttons
                    item-text="name"
                    item-value="id"
                    class="search-bar"
                    no-filter
                    :search-input.sync="searchQuery"
                    :loading="isSearching"
                    return-object
                    clearable
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item @click="addProductToOrder(item)">
                        <v-list-item-avatar>
                          <v-img
                            :src="item.image"
                            alt="Ảnh sản phẩm"
                          ></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            <span v-html="item.name"></span>
                            <v-spacer></v-spacer>
                            {{ formatCurrency(item.retail_cost) }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-card outlined class="pa-3 mb-4">
                    <v-row class="mb-2">
                      <v-col cols="12" class="d-flex justify-space-between">
                        <span>Giỏ hàng</span>
                      </v-col>
                    </v-row>
                    <v-row v-if="selectedProducts.length === 0">
                      <v-col cols="12" class="text-center grey--text">
                        Chưa có sản phẩm nào trong đơn hàng
                      </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col
                        cols="12"
                        v-for="(item, index) in selectedProducts"
                        :key="item._uniqueKey || item.id"
                        class="py-1"
                      >
                        <v-row align="center">
                          <v-col cols="1">{{ index + 1 }}</v-col>
                          <v-col cols="5">{{ item.name }}</v-col>
                          <v-col cols="3">
                            <v-text-field
                              v-model.number="item.quantity"
                              type="number"
                              min="1"
                              dense
                              hide-details
                              @input="validateQuantity(item)"
                              @keypress="preventNegativeNumber"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">{{ formatCurrency(item.retail_cost * item.quantity) }}</v-col>
                          <v-col cols="1">
                            <v-icon small @click="removeProduct(item)">mdi-delete</v-icon>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="formattedAmountPaid"
                    placeholder="Nhập số tiền"
                    label="Khách đã trả"
                    prepend-inner-icon="mdi-cash"
                    outlined
                    dense
                    hide-details
                    @input="onAmountPaidInput"
                    @focus="onAmountPaidFocus"
                    @blur="formatAmountPaidOnBlur"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="orderStatus"
                    :items="[
                      { text: 'Thành công', value: 2 },
                      { text: 'Chờ xác nhận', value: 1 }
                    ]"
                    label="Trạng thái"
                    outlined
                    dense
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formattedOrderDate"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        dense
                        outlined
                        hide-details
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="orderDate"
                      @input="dateMenu = false"
                      no-title
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <div>
                    <div>Tổng đơn</div>
                    <div class="text-h6">{{ formatCurrency(totalAmount) }}</div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          text
          color="grey darken-1"
          @click="toggle()"
          :disabled="loading"
          class="px-4"
        >
          <v-icon left>mdi-cancel</v-icon>
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary"
          @click="submit"
          :loading="loading"
          :disabled="!valid || loading"
          class="px-6"
          elevation="2"
        >
          <v-icon left>mdi-content-save</v-icon>
          Lưu
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import customerModule from '@/api/customers'
import orderModule from '@/api/order'
import productModule from '@/api/products'

const customerActions = customerModule.actions
const orderActions = orderModule.actions
const productActions = productModule.actions

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    isAdminUser: {
      type: Boolean,
      default: false
    },
    saleTabs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      valid: true,
      loading: false,
      name: '',
      phone: '',
      email: '',
      address: '',
      total_money: 0,
      saleUserId: null,
      dataType: 'successful',
      dataTypeOptions: [
        { text: 'Đã mua hàng', value: 'successful' },
        { text: 'Khách tiềm năng (chưa mua hàng)', value: 'potential' }
      ],
      note: '',
      health_needs: [],
      healthNeedsList: [
        'Xương khớp',
        'Tiểu đường',
        'Tăng cân',
        'Giảm cân',
        'Con cần dinh dưỡng',
        'Tiêu hóa'
      ],
      createOrderWithCustomer: false,
      searchProduct: null,
      searchQuery: '',
      listProduct: [],
      selectedProducts: [],
      isSearching: false,
      debounceTimeout: null,
      amountPaid: 0,
      formattedAmountPaid: '0',
      orderStatus: 2,
      orderDate: new Date().toISOString().substr(0, 10),
      dateMenu: false,
      nameRules: [
        v => !!v || 'Tên khách hàng không được để trống'
      ],
      phoneRules: [
        v => !!v || 'Số điện thoại không được để trống',
        v => /^[0-9]+$/.test(v) || 'Số điện thoại không hợp lệ'
      ],
      emailRules: [
        v => !v || /.+@.+\..+/.test(v) || 'Email không hợp lệ'
      ]
    }
  },
  watch: {
    open(value) {
      if (value && this.createOrderWithCustomer) {
        this.fetchProducts();
      }
    },
    createOrderWithCustomer(value) {
      if (value) {
        this.fetchProducts();
      }
    },
    searchQuery(newValue) {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = setTimeout(() => {
        this.fetchProducts(newValue);
      }, 200);
    }
  },
  computed: {
    totalAmount() {
      return this.selectedProducts.reduce((sum, item) => {
        return sum + (item.retail_cost * item.quantity);
      }, 0);
    },
    formattedOrderDate() {
      if (!this.orderDate) return '';
      const [year, month, day] = this.orderDate.split('-');
      return `${day}/${month}/${year}`;
    }
  },
  methods: {
    formatCurrency() {
      this.total_money = this.total_money.toString().replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '0';
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    removeHealthNeed(item) {
      const index = this.health_needs.indexOf(item);
      if (index >= 0) this.health_needs.splice(index, 1);
    },
    toggle() {
      if (!this.loading) {
        this.$emit('toggle');
        this.resetForm();
      }
    },
    resetForm() {
      this.name = '';
      this.phone = '';
      this.email = '';
      this.address = '';
      this.total_money = 0;
      this.saleUserId = null;
      this.dataType = 'successful';
      this.note = '';
      this.health_needs = [];
      this.createOrderWithCustomer = false;
      this.searchProduct = null;
      this.searchQuery = '';
      this.listProduct = [];
      this.selectedProducts = [];
      this.isSearching = false;
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = null;
      this.amountPaid = 0;
      this.formattedAmountPaid = '0';
      this.orderStatus = 2;
      this.orderDate = new Date().toISOString().substr(0, 10);
      this.dateMenu = false;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit() {
      if (!this.$refs.form.validate()) return;

      if (this.createOrderWithCustomer && this.selectedProducts.length === 0) {
        this.$snackbar.error('Vui lòng chọn ít nhất một sản phẩm để tạo đơn hàng kèm khách hàng.');
        return;
      }

      this.loading = true;

      const customerData = {
        name: this.name,
        phone: this.phone,
        email: this.email,
        address: this.address,
        total_money: parseInt(this.total_money ? this.total_money.toString().replace(/\D/g, '') : '0'),
        note: this.note,
        data_type: this.dataType,
        health_needs: this.health_needs
      };

      if (this.isAdminUser && this.saleUserId) {
        customerData.user_id = this.saleUserId;
      }

      customerActions.createCustomer(customerData).then(res => {
        const customerId = res.data?.data?.id || res.data?.id;
        if (this.createOrderWithCustomer) {
          this.createOrder(customerId);
        } else {
          this.onCustomerCreated();
        }
      }).catch(err => {
        this.loading = false;
        if (err.response && err.response.data && err.response.data.errors) {
          const errors = err.response.data.errors;
          if (errors.phone) {
            this.$snackbar.error(errors.phone[0]);
          } else {
            this.$snackbar.error('Có lỗi xảy ra khi tạo khách hàng!');
          }
        } else {
          this.$snackbar.error('Có lỗi xảy ra!');
        }
      });
    },
    onCustomerCreated() {
      this.loading = false;
      this.resetForm();
      this.$snackbar.success('Tạo mới khách hàng thành công!');
      this.$emit('toggle');
      this.$emit('refresh');
    },
    createOrder(customerId) {
      const orderData = {
        customer_id: customerId,
        payment: {
          price: this.amountPaid,
          type: 1
        },
        is_retail: true,
        discount: 0,
        discount_type: 2,
        total_amount: this.totalAmount,
        final_amount: this.totalAmount,
        status: this.orderStatus,
        type: 1,
        create_date: this.orderDate,
        order_detail: this.processOrderDetails()
      };

      orderActions.createOrder(orderData).then(() => {
        this.$snackbar.success('Tạo mới khách hàng và đơn hàng thành công!');
        this.onCustomerCreated();
      }).catch(err => {
        this.loading = false;
        this.$snackbar.error('Khách hàng đã được tạo, nhưng tạo đơn hàng thất bại.');
        console.error('Error creating order with new customer:', err);
      });
    },
    processOrderDetails() {
      return this.selectedProducts.map(item => ({
        product_id: item.id,
        quantity: item.quantity,
        discount: 0,
        discount_type: 2,
        price: item.retail_cost,
        is_gift: item.is_gift ? 1 : 0
      }));
    },
    fetchProducts(searchTerm) {
      const payload = {
        per_page: 20,
        name: searchTerm || this.searchQuery || ''
      };
      this.isSearching = true;
      productActions.getProductsV2(payload)
        .then(response => {
          this.listProduct = response.data?.data || [];
        })
        .catch(error => {
          console.error('Error fetching products:', error);
          this.$snackbar.error('Không thể tìm kiếm sản phẩm');
        })
        .finally(() => {
          this.isSearching = false;
        });
    },
    addProductToOrder(item) {
      const uniqueKey = Date.now() + Math.random();
      const newProduct = {
        ...item,
        quantity: 1,
        _uniqueKey: uniqueKey,
        is_gift: false
      };
      this.selectedProducts.push(newProduct);
      this.searchProduct = null;
      this.searchQuery = '';
      this.$nextTick(() => {
        if (this.$refs.productSearch) {
          this.$refs.productSearch.blur();
          this.$refs.productSearch.isMenuActive = false;
        }
      });
    },
    removeProduct(item) {
      const index = this.selectedProducts.findIndex(product =>
        product._uniqueKey ? product._uniqueKey === item._uniqueKey : product.id === item.id
      );
      if (index !== -1) {
        this.selectedProducts.splice(index, 1);
      }
    },
    validateQuantity(item) {
      const quantity = parseInt(item.quantity, 10);
      if (!quantity || quantity < 1) {
        item.quantity = 1;
        this.$snackbar.warning('Số lượng phải lớn hơn 0');
      } else {
        item.quantity = quantity;
      }
    },
    preventNegativeNumber(evt) {
      if (evt.key === '-' || evt.key === 'e' || evt.key === '+') {
        evt.preventDefault();
      }
    },
    onAmountPaidInput(value) {
      const numericValue = value ? value.toString().replace(/[^\d]/g, '') : '';
      this.amountPaid = parseFloat(numericValue) || 0;
      this.formattedAmountPaid = this.formatNumber(this.amountPaid);
    },
    formatAmountPaidOnBlur() {
      this.formattedAmountPaid = this.formatNumber(this.amountPaid);
    },
    onAmountPaidFocus() {
      this.formattedAmountPaid = this.amountPaid.toString();
    }
  }
};
</script>

<style scoped>
.v-card {
  overflow: hidden;
}

.v-toolbar {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.v-text-field ::v-deep .v-input__slot {
  min-height: 44px !important;
}

.v-btn {
  text-transform: none !important;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.v-btn.v-btn--contained {
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.4) !important;
}

.v-btn.v-btn--contained:hover {
  box-shadow: 0 6px 15px rgba(26, 115, 232, 0.5) !important;
}
</style>
